export const getFieldErrors = state => state.fieldErrorsReducer.fieldErrors;
export const getFieldError = (state, props) => getFieldErrors(state)[props.name];
export const getFormError = state => state.fieldErrorsReducer.formError;
export const getFieldErrorsVisible = state => state.fieldErrorsReducer.errorsVisible;
